<app-modals [title]="title" [description]="description" [openModal]="openModal" [whenModalClose]="whenModalClose" [closeModal]="closeModal" [submitKey]="submitKey" [isButtonsDisabled]="isButtonsDisabled" [invalidFormGroup]="$safeNavigationMigration(entry?.invalid)" [onDismiss]="onDismiss" [config]="{ class: 'modal-lg' }" [isShaking]="$safeNavigationMigration(errors?.length) > 0">
  <div class="row">
    <div class="col-12 col-md-8 d-flex align-items-center">
      <div class="small">{{ 'MODALS.REFERENCE_RELATIONSHIPS.LANGUAGE' | translate : { type: ('TYPES.RELATIONSHIP' | translate) } }}</div>
    </div>

    <div class="col-12 col-md-4">
      <div class="input-group"><select class="form-control form-select" id="language" [(ngModel)]="selectedLanguage">
        @for (l of languages; track l) {
          <option [ngValue]="l.id">{{ l.label }}</option>
        }
      </select></div>
    </div>
  </div>
  <hr />
  <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit(entry)" novalidate="novalidate">
    <div class="row">
      @for (r of formArrayReferenceRelationships.controls; track r; let i = $index) {
        @if (r.value.language === selectedLanguage) {
          <div class="col-12 col-md-4" formArrayName="relationships">
            <div [formGroupName]="i" [ngClass]="{ 'text-danger': r.get('label').invalid && r.get('label').touched }"><label class="form-control-label font-italic required" for="label{{i}}">{{ 'MODALS.REFERENCE_RELATIONSHIPS.RELATIONSHIP_NUMBER' | translate }}{{ i + 1 }}@if (r.get('label').invalid && r.get('label').touched) {
              <span>@if (r.get('label').hasError('required')) {
                <small class="fadeIn">{{ 'FORMS.ERRORS.REQUIRED' | translate }}</small>
              }</span>
            }</label>
            <div class="input-group mb-3"><span class="input-group-text">{{ r.get('value').value }}</span><input class="form-control" type="text" autocomplete="label" [id]="'relationship_' + i" formControlName="label" /><button class="btn v-btn-danger" type="button" (click)="deleteItem(i)" [disabled]="isButtonsDisabled"><i class="lnr lnr-trash2"></i></button></div>
          </div>
        </div>
      }
    }
  </div>

  <div class="row">
    <div class="col-12"><button class="btn v-btn-primary float-end" type="button" (click)="addItem()" [disabled]="isButtonsDisabled">{{ 'BUTTONS.ADD' | translate : { type: ('TYPES.RELATIONSHIP' | translate) } }}</button></div>
  </div>
</form>
</app-modals>
